/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '@/services/toast';
import countries from '@/services/country.json';
import allCountries from './phoneCodeList.json';
import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import {
  mapGetters
} from 'vuex';
export default {
  name: 'update-user-info-for-team',
  components: {
    datetime: Datetime,
  },
  props: [],
  data () {
    return {
      submitted:false,
      first_name:'',
      last_name:'',
      email:'',
      organization:'',
      area_of_work:'',
      department:'',
      countryList: [],
      country:'',
      city:'',
      allCountriesList:[],
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      userFilter:'',
      name_prefix:'Please Select',
      name_prefix_updated:'',
      prefix_dr_specialties:'',
      userFilter:'',
      accept_terms:'',
      other_doctor_cat:'',
      enabled_other_d_cat:false,
      professional_category:'',
      countryPrint:'',
      areaOfSpecialization:'',
      phoneNumber:{
        fullOTP:''
      },
      memberAllFilterList:{},
      memberAllFilterListResults:[],
      extraSubCatState:[],
      selfUserID:'',
      userInfoByTeamHead:null
    }
  },
  computed: {
    ...mapGetters([
      'getUserInfoByIdForTeamHeadGetters'
    ]),
    getUserInfoByIdFun() {
      this.userInfoByTeamHead = this.$store.getters.getUserInfoByIdForTeamHeadGetters.data
      return
    },
    SetIntialStatus() {
     if(this.userInfoByTeamHead){
       this.first_name = this.userInfoByTeamHead.first_name
       this.last_name = this.userInfoByTeamHead.last_name
       this.name_prefix = this.userInfoByTeamHead.salutation ||  'Please Select'
       this.name_prefix_updated = this.userInfoByTeamHead.salutation || ''
       this.email = this.userInfoByTeamHead.email
       this.area_of_work = this.userInfoByTeamHead.profile.area_of_work
       this.department = this.userInfoByTeamHead.profile.department
       this.country = this.userInfoByTeamHead.profile.country
       this.city = this.userInfoByTeamHead.profile.city
       this.activeStatus = this.userInfoByTeamHead.is_active
       this.phone.countryCode = this.userInfoByTeamHead.profile.mobile_country_code  || '+91'
       this.phone.number = this.userInfoByTeamHead.profile.mobile
       this.professional_category = this.userInfoByTeamHead.profile.professional_filter_category
       this.areaOfSpecialization = this.userInfoByTeamHead.profile.professional_filter_name
       this.other_doctor_cat = this.userInfoByTeamHead.profile.professional_category
       setTimeout(()=>{
         if(this.phone.countryCode != null && this.phone.countryCode != ''){
           var countrySplit = this.phone.countryCode
           var phoneCountry = countrySplit.replace('+', '');
           this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
           }
       },100)
     }
     return
   }
  },
  mounted () {
    this.selfUserID = localStorage.getItem('LoginedUserID');
    this.getUserCountry();
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
    this.getProfessionCategoriesListMethods()
  },
  methods: {
    getProfessionCategoriesListMethods(){
      this.$store.dispatch('getMemberFilterListForSignupFun')
        .then((res) => {  
          this.memberAllFilterList = res.data.data
          if(this.memberAllFilterList != undefined){
            this.memberAllFilterListResults = this.memberAllFilterList.results
          }
        }).catch((err)=>{
        })
    },
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
            let data = {
              first_name:this.first_name,
              last_name:this.last_name,
              email:this.email,
              salutation:this.name_prefix_updated,
              professional_filter_category:this.professional_category,
              professional_filter_name:this.areaOfSpecialization,
              added_by_user:this.selfUserID
            }
            if(this.area_of_work != null && this.area_of_work != ''){
              data.area_of_work = this.area_of_work;
            }
            if(this.department != null && this.department != ''){
              data.department = this.department;
            }
            if(this.country != null && this.country != ''){
              data.country = this.country;
            }
            if(this.city != null && this.city != ''){
              data.city = this.city;
            }
            if(this.phone.countryCode != null && this.phone.countryCode != ''){
              data.mobile_country_code = '+' + this.phone.countryCode;
            }
            if(this.phone.number != null && this.phone.number != ''){
              data.mobile = this.phone.number;
            }
            if(this.other_doctor_cat != null && this.other_doctor_cat != ''){
              data.professional_category = this.other_doctor_cat;
            }
            this.$store.dispatch('updateUserInfoForTeamFun', {data:{data: data, id: this.$route.params.updateID}})
              .then((res) => {  
                  toast.success(res.data.msg);            
                  this.$router.push({ name: 'teamUserList'})
                  this.submitted = false
              }).catch((err) => {
                toast.error(err.data.data.email || err.data.user_msg || err.data.msg);
                this.submitted = false
              })
            return;
        }
      });
    },
    titleChangedMethod(name, val){
      this.name_prefix = name
      if(val == 'Medical_Doctor'){
        this.name_prefix_updated = 'Dr'
      }else if(val == 'PhD_Doctor'){
        this.name_prefix_updated = 'Dr'
      }else{
        this.name_prefix_updated = val
      }
    },
    professionSelectCatFun(filterKey,filterCatVal,filterSubCatVal){
        this.professional_category = filterKey
        this.areaOfSpecialization = filterCatVal
        if(filterSubCatVal.length > 0){
          this.enabled_other_d_cat = true
          this.extraSubCatState = filterSubCatVal
        }else{
          this.enabled_other_d_cat = false
          this.other_doctor_cat = ''
        }
    },
    otherDoctorSelectCatFun(ODFilterVal){
      this.other_doctor_cat = ODFilterVal
    },
  },
  watch: {
    getUserInfoByIdFun() {
      return this.$store.getters.orgUserDetailsByIdGetters.data
    },
    SetIntialStatus() {
     if(this.userInfoByTeamHead){
       this.first_name = this.userInfoByTeamHead.first_name
       this.last_name = this.userInfoByTeamHead.last_name
       this.name_prefix = this.userInfoByTeamHead.salutation ||  'Please Select'
       this.name_prefix_updated = this.userInfoByTeamHead.salutation || ''
       this.email = this.userInfoByTeamHead.email
       this.area_of_work = this.userInfoByTeamHead.profile.area_of_work
       this.department = this.userInfoByTeamHead.profile.department
       this.country = this.userInfoByTeamHead.profile.country
       this.city = this.userInfoByTeamHead.profile.city
       this.activeStatus = this.userInfoByTeamHead.is_active
       this.phone.countryCode = this.userInfoByTeamHead.profile.mobile_country_code  || '+91'
       this.phone.number = this.userInfoByTeamHead.profile.mobile
       this.professional_category = this.userInfoByTeamHead.profile.professional_filter_category
       this.areaOfSpecialization = this.userInfoByTeamHead.profile.professional_filter_name
       this.other_doctor_cat = this.userInfoByTeamHead.profile.professional_category
       setTimeout(()=>{
         if(this.phone.countryCode != null && this.phone.countryCode != ''){
           var countrySplit = this.phone.countryCode
           var phoneCountry = countrySplit.replace('+', '');
           this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
           }
       },100)
     }
     return
   }
  }
}